// extracted by mini-css-extract-plugin
module.exports = {"images":"PartnersList_images__wA71O"};